export default __webpack_public_path__ + "static/media/1000+.39d75b97.png";